import React, { useState, useEffect, useRef } from 'react';
import { Card, CardContent, Box, Grid } from '@mui/material';
import { Refresh, CheckCircle, Schedule, Cancel } from '@mui/icons-material';
import { useHistory } from 'react-router-dom';
import { validarSeDocumentoFoiAtualizado } from 'api/clientSearch';
import Main from '../Main/Main';
import ButtonMain from '../Onboarding/shared/ButtonMain';
import Empresa from './Empresa/Empresa';
import Sociedade from './Sociedade/Sociedade';
// ###### ====== FUTURO DESENVOLVIMENTO DE UPLOAD DE DOCUMENTOS DE GARANTIA ====== ######
// import Garantia from './Garantia/Garantia';
import { getClienteAtual } from '../../shared/services/User';
import {
  getDocumentosEnviadosCliente,
  getListaTiposDocumentos,
  listarUltimaPPC
} from '../../api/onboarding';
import AlertErroMain from '../Onboarding/shared/AlertErroMain';
import HistoricoAcesso from '../commom/HistoricoAcesso';

export default function Documentos(props) {
  const [mudaAbaDocumentos, setMudaAbaDocumentos] = useState('Empresa');
  const [estadoUltimaPPC, setEstadoUltimaPPC] = useState('');
  const [isPendingEmpresa, setPendingEmpresa] = useState(false);
  const [dadosDocumentosEmpresa, setDadosDocumentosEmpresa] = useState({});
  const [alertaEmpresa, setAlertaEmpresa] = useState(false);
  const [isPendingSociedade, setPendingSociedade] = useState(false);
  const [dadosDocumentosSociedade, setDadosDocumentosSociedade] = useState({});
  // const [alertaSociedade, setAlertaSociedade] = useState(false);
  // ###### ====== FUTURO DESENVOLVIMENTO DE UPLOAD DE DOCUMENTOS DE GARANTIA ====== ######
  // const [isPendingGarantia, setPendingGarantia] = useState(false);
  // const [dadosDocumentosGarantia, setDadosDocumentosGarantia] = useState({});
  // const [alertaGarantia, setAlertaGarantia] = useState(false);
  const [detalhesDocumentos, setDetalhesDocumentos] = useState(false);
  const [listaTiposDocumentos, setListaTiposDocumentos] = useState([]);
  const [clienteSelecionado, setClienteSelecionado] = useState(false);
  const [documentosAtualizados, setDocumentosAtualizados] = useState();
  const [mostraErro, setMostraErro] = useState(false);

  const history = useHistory();
  const cliente = getClienteAtual();

  // trava para evitar múltiplas chamadas por mesmo CNPJ
  const lastFetchedCnpjRef = useRef(null);

  const iconeStatus = {
    APROVADO: <CheckCircle className="font-size-14 texto-success" sx={{ mr: '10px' }} />,
    REPROVADO: <Cancel className="font-size-14 texto-danger" sx={{ mr: '10px' }} />,
    ANALISE: <Schedule className="font-size-14 texto-warning" sx={{ mr: '10px' }} />
  };

  const mudaAba = value => {
    setMudaAbaDocumentos(value);
  };

  useEffect(() => {
    carregarTodasAbas();
    // BUSCA OS TIPOS
    getListaTiposDocumentos()
      .then(retornoTipos => {
        let ret = retornoTipos.data;
        if (ret.dados && ret.dados.length > 0) {
          setListaTiposDocumentos(ret.dados);
        }
      })
      .catch(err => {
        setMostraErro(err.response);
      });
  }, []);

  useEffect(() => {
    if (cliente) {
      listarUltimaPPC(cliente.cnpj)
        .then(response => {
          const data = response.data;
          setEstadoUltimaPPC(data.ESTADOPPC);
        })
        .catch(() => {
          setEstadoUltimaPPC('');
        });
    }
  }, [estadoUltimaPPC]);

  const carregarTodasAbas = () => {
    if (cliente === null || cliente.cnpj === undefined || cliente.id === 'todos') history.push('/home');
    setClienteSelecionado(cliente);

    // permite refazer a checagem de atualização ao “Atualizar Tudo”
    lastFetchedCnpjRef.current = null;
    setDocumentosAtualizados(undefined);

    carregarAbaEmpresa(cliente.cnpj);
    carregarAbaSociedade(cliente.cnpj);
    // \/ ###### ====== FUTURO DESENVOLVIMENTO DE UPLOAD DE DOCUMENTOS DE GARANTIA ====== ###### \/
    // carregarAbaGarantia(clienteSelecionado.cnpj);
  };

  const carregarAbaEmpresa = (cnpjCliente = false) => {
    let cnpj = cnpjCliente ? cnpjCliente : clienteSelecionado && clienteSelecionado.cnpj;
    if (!cnpj) return;

    setPendingEmpresa(true);
    var params = {
      cnpj: cnpj,
      pesquisado_por: 'EMPRESA'
    };
    getDocumentosEnviadosCliente(params)
      .then(retorno => {
        let dados = retorno.data;
        if (dados.processado && dados.detalhes) {
          setDadosDocumentosEmpresa(dados.detalhes.empresa);
        } else {
          setDadosDocumentosEmpresa({});
        }
      })
      .catch(err => {
        setMostraErro(err.response);
      })
      .finally(() => {
        setPendingEmpresa(false);
      });
  };

  const carregarAbaSociedade = (cnpjCliente = false) => {
    let cnpj = cnpjCliente ? cnpjCliente : clienteSelecionado && clienteSelecionado.cnpj;
    if (!cnpj) return;

    setPendingSociedade(true);
    var params = {
      cnpj: cnpj,
      pesquisado_por: 'SOCIOS'
    };
    getDocumentosEnviadosCliente(params)
      .then(retorno => {
        let dados = retorno.data;
        if (dados.processado && dados.detalhes) {
          setDadosDocumentosSociedade(dados.detalhes.socios);
        } else {
          setDadosDocumentosSociedade({});
        }
      })
      .catch(err => {
        setMostraErro(err.response);
      })
      .finally(() => {
        setPendingSociedade(false);
      });
  };

  // ###### ====== FUTURO DESENVOLVIMENTO DE UPLOAD DE DOCUMENTOS DE GARANTIA ====== ######
  // const carregarAbaGarantia = (cnpjCliente = false) => {
  //   let cnpj = cnpjCliente ? cnpjCliente : clienteSelecionado.cnpj;
  //   setPendingGarantia(true);
  //   getDocumentosEnviadosCliente(cnpj, 'GARANTIAS')
  //     .then(retorno => {
  //       let dados = retorno.data;
  //       if (dados.processado && dados.detalhes) {
  //         setDadosDocumentosGarantia(dados.detalhes.garantias);
  //       } else {
  //         setDadosDocumentosGarantia({});
  //       }
  //     })
  //     .finally(() => {
  //       setPendingGarantia(false);
  //     })
  //     .catch(err => {
  //       setMostraErro(err.response);
  //     });
  // };

  // Busca “documentosAtualizados” apenas 1x por CNPJ (e só se limite vencendo = 'S')
  useEffect(() => {
    let ativo = true;

    const cnpj = clienteSelecionado && clienteSelecionado.cnpj ? clienteSelecionado.cnpj : '';
    const limiteVencendo =
      clienteSelecionado && clienteSelecionado.limiteVencendo ? clienteSelecionado.limiteVencendo : 'N';

    if (cnpj !== '' && limiteVencendo === 'S' && lastFetchedCnpjRef.current !== cnpj) {
      validarSeDocumentoFoiAtualizado(cnpj)
        .then(response => {
          if (ativo) {
            setDocumentosAtualizados(response.data.qtde);
            lastFetchedCnpjRef.current = cnpj;
          }
        })
        .catch(err => {
          if (ativo) setMostraErro(err.response);
        });
    }

    // se não há limite vencendo, limpamos o indicador para não gerar alertas residuais
    if (limiteVencendo !== 'S' && ativo) {
      setDocumentosAtualizados(undefined);
    }

    return () => {
      ativo = false;
    };
  }, [clienteSelecionado]);

  // Cálculo dos alertas (separado da busca para evitar loops / re-fetch)
  useEffect(() => {
    listarUltimaPPC(clienteSelecionado.cnpj).then(response => {
      const data = response.data;
      if (data.ESTADOPPC) {
        setEstadoUltimaPPC(data.ESTADOPPC);
      }
    });
    if (
      (dadosDocumentosEmpresa.dados &&
        dadosDocumentosEmpresa.dados.status_documentos === 'REPROVADO' &&
        !['FIM', 'INA'].includes(estadoUltimaPPC)) ||
      (clienteSelecionado &&
        clienteSelecionado.limiteVencendo === 'S' &&
        documentosAtualizados === 0 &&
        ['FIM', 'INA'].includes(estadoUltimaPPC))
    ) {
      setAlertaEmpresa(true);
    } else {
      setAlertaEmpresa(false);
    }

    // setAlertaSociedade(false);
    // if (dadosDocumentosSociedade && Object.keys(dadosDocumentosSociedade).length > 0) {
    //   Object.keys(dadosDocumentosSociedade).map(chaveSocio => {
    //     if (
    //       dadosDocumentosSociedade[chaveSocio] &&
    //       dadosDocumentosSociedade[chaveSocio].dados &&
    //       dadosDocumentosSociedade[chaveSocio].dados.status_documentos === 'REPROVADO'
    //     ) {
    //       setAlertaSociedade(true);
    //     }
    //     return chaveSocio;
    //   });
    // }

    // setAlertaGarantia(false);
    // if (Object.keys(dadosDocumentosGarantia).length > 0) {
    //   Object.keys(dadosDocumentosGarantia).map(chaveGarantia => {
    //     if (dadosDocumentosGarantia[chaveGarantia].dados.status_documentos === 'REPROVADO') {
    //       setAlertaGarantia(true);
    //     }
    //   });
    // }
  }, [
    dadosDocumentosEmpresa,
    dadosDocumentosSociedade,
    documentosAtualizados /*, dadosDocumentosGarantia*/
  ]);

  return (
    <>
      <Main title="Documentos" {...props}>
        <Card sx={{ mb: '50px' }}>
          <CardContent sx={{ pr: '30px', pl: '30px' }}>
            {detalhesDocumentos === false && (
              <>
                <Box sx={{ p: '20px 0' }}>
                  <h1>Status da documentação</h1>
                  <p>
                    Mantenha a documentação da empresa e dos sócios atualizada para garantir uma melhor
                    análise de crédito
                  </p>
                </Box>
                <Box>
                  <Box className="w-mw-40px float-right">
                    <ButtonMain
                      tipoBotao="transparente-com-bordas-complementar"
                      classesAdicional="w-mw-40px"
                      onClick={() => carregarTodasAbas()}
                      title="Atualizar Tudo"
                    >
                      <Refresh />
                    </ButtonMain>
                  </Box>
                  <Grid container spacing={3}>
                    <Grid item lg={4} md={4} sm={6} xs={12}>
                      <ButtonMain
                        tipoBotao={
                          mudaAbaDocumentos === 'Empresa'
                            ? 'azul-escuro'
                            : 'transparente-com-bordas-principal'
                        }
                        onClick={() => mudaAba('Empresa')}
                      >
                        Documentos da empresa
                        {alertaEmpresa && <div className="icone-alert-right-top" />}
                      </ButtonMain>
                    </Grid>
                    {/* {clienteSelecionado &&
                    clienteSelecionado.limiteVencendo === 'S' &&
                    documentosAtualizados === 0 &&
                    ['FIM', 'INA'].includes(estadoUltimaPPC) ? (
                      ''
                    ) : (
                      <Grid item lg={4} md={4} sm={6} xs={12}>
                        <ButtonMain
                          tipoBotao={
                            mudaAbaDocumentos === 'Sociedade'
                              ? 'azul-escuro'
                              : 'transparente-com-bordas-principal'
                          }
                          onClick={() => mudaAba('Sociedade')}
                        >
                          Documentos da sociedade
                          {alertaSociedade && <div className="icone-alert-right-top" />}
                        </ButtonMain>
                      </Grid>
                    )} */}
                    {/* ###### ====== FUTURO DESENVOLVIMENTO DE UPLOAD DE DOCUMENTOS DE GARANTIA ====== ###### */}
                    {/* <Grid item lg={4} md={4} sm={6} xs={12}>
                    <ButtonMain
                      tipoBotao={
                        mudaAbaDocumentos === 'Garantias'
                          ? 'azul-escuro'
                          : 'transparente-com-bordas-principal'
                      }
                      onClick={() => mudaAba('Garantias')}
                    >
                      Documentos da garantia
                      {alertaGarantia && <div className="icone-alert-right-top" />}
                    </ButtonMain>
                  </Grid> */}
                  </Grid>
                </Box>
              </>
            )}

            <Box sx={{ p: '40px 0' }}>
              {mudaAbaDocumentos === 'Empresa' && (
                <Empresa
                  dadosDocumentosEmpresa={dadosDocumentosEmpresa}
                  setDadosDocumentosEmpresa={setDadosDocumentosEmpresa}
                  detalhesDocumentos={detalhesDocumentos}
                  setDetalhesDocumentos={setDetalhesDocumentos}
                  iconeStatus={iconeStatus}
                  listaTiposDocumentos={listaTiposDocumentos}
                  clienteSelecionado={clienteSelecionado}
                  isPending={isPendingEmpresa}
                  carregarAbaEmpresa={carregarAbaEmpresa}
                />
              )}
              {mudaAbaDocumentos === 'Sociedade' && (
                <Sociedade
                  dadosDocumentosSociedade={dadosDocumentosSociedade}
                  setDadosDocumentosSociedade={setDadosDocumentosSociedade}
                  detalhesDocumentos={detalhesDocumentos}
                  setDetalhesDocumentos={setDetalhesDocumentos}
                  iconeStatus={iconeStatus}
                  listaTiposDocumentos={listaTiposDocumentos}
                  clienteSelecionado={clienteSelecionado}
                  isPending={isPendingSociedade}
                  carregarAbaSociedade={carregarAbaSociedade}
                />
              )}
              {/* ###### ====== FUTURO DESENVOLVIMENTO DE UPLOAD DE DOCUMENTOS DE GARANTIA ====== ###### */}
              {/* mudaAbaDocumentos === 'Garantias' && (
              <Garantia
                dadosDocumentosGarantia={dadosDocumentosGarantia}
                setDadosDocumentosGarantia={setDadosDocumentosGarantia}
                detalhesDocumentos={detalhesDocumentos}
                setDetalhesDocumentos={setDetalhesDocumentos}
                iconeStatus={iconeStatus}
                listaTiposDocumentos={listaTiposDocumentos}
                clienteSelecionado={clienteSelecionado}
                isPending={isPendingGarantia}
                carregarAbaGarantia={carregarAbaGarantia}
              />
            ) */}
            </Box>
            <AlertErroMain exibeErro={mostraErro} escondeErro={setMostraErro} />
          </CardContent>
        </Card>
      </Main>
      <HistoricoAcesso codTela={1182} />
    </>
  );
}
